export default "__VITE_ASSET__DOgRxUD4__ 720w";